import type {FunctionComponent} from "react";
import {CheckCircleOutlined} from "@mui/icons-material";
import type {ToastContentProps} from "react-toastify";
import ToastContent from "../../index";

export interface IApiResponseSuccessToastContent {
    message: string,
    title?: string,
}

const ApiResponseSuccessToastContent: FunctionComponent<ToastContentProps<IApiResponseSuccessToastContent>> = (props) => {

    return (
        <>
            <ToastContent
                title={props.data.title}
                message={props.data?.message ?? ''}
                icon={<CheckCircleOutlined color={'success'}/>}
                className={typeof props.toastProps.className === 'string' ? props.toastProps.className : ''}
                toastProps={props.toastProps}
            />
        </>
    )
}

export default ApiResponseSuccessToastContent;
